import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Button, Toast, TextArea, Checkbox } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import styles from './index.module.scss';
import { CheckCircleOutline } from 'antd-mobile-icons'
const api = new ApiCore();


const CSOFeedBack = (props: any) => {
    const [checked, setChecked] = useState<boolean>(false)
    const [value, setValue] = useState<any>('')

    useEffect(() => {
        window.document.title = '意见反馈'
        return () => {
        }
    }, [])



    const submit = () => {
        if (!value) {
            Toast.show({
                content: '请填写所遇问题的具体描述'
            })
        } else if (!checked) {
            Toast.show({
                content: '请先勾选同意'
            })
        } else {
            Toast.show({
                icon: 'success',
                content: '提交成功',
            })
            props.history.go(-1)
            setValue('')
        }
    }


    return (
        <div className={styles.feedback_container}>

            <div className={styles.feedback_top}>
                <div className={styles.feedback_title}>请填写以下信息进行反馈</div>
                <div className={styles.feedback_tip}>非常抱歉给您带来不便，我们重视每一位用户的体验，请填写信息帮助我们明确问题。</div>
            </div>
            <div className={styles.feedback_content}>
                <div className={styles.feedback_desc}>您所遇问题的具体描述</div>
                <div>
                    <TextArea
                        value={value}
                        style={{ '--font-size': '12px' }}
                        placeholder='请填写所遇问题的具体描述，以便我们更好的发现问题'
                        rows={4}
                        showCount
                        maxLength={100}
                        onChange={v => setValue(v)}
                    />
                </div>
            </div>

            <div className={styles.myCheckbox}>
                {
                    checked ? (
                        <span className={styles.icon_checked} onClick={() => setChecked(!checked)}></span>
                    ) : (
                        <span className={styles.icon_unChecked} onClick={() => setChecked(!checked)}></span>
                    )
                }
                <div className={styles.myCheckbox_label}>同意将反馈描述和手机号提供给本应用，以便更好的解决问题</div>
            </div>

            <div className={styles.myButton}>
                <Button color='primary' fill='solid' onClick={submit}>
                    提交
                </Button>
            </div>

        </div>
    )
}

export default withRouter(CSOFeedBack);